import styled from 'styled-components';

export const Wrapper = styled.div`
	// border-radius: 24px 24px 0px 0px;
    padding: 0 16px;
	background: rgb(233,247,245);
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	position: fixed;
	bottom: 0px;
    z-index: 999;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.20);
	@media (max-width: 1100px) {
		bottom: 50px;
	}
	.row-flex {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 3px;
        cursor: pointer;
	}
	.button {
		font-weight: 1000;
		font-size: 15px;
		color: #201E67;;
	}
    .icon {
        width: 25px;
        height: 25px;
        color: #201E67;;
        font-weight: 1000;
        cursor: pointer;
    }
`